<!--既往TIPS治疗-->
<script setup>
import { computed, reactive, watch,ref } from "vue";
import { useCrfStore } from "@/stores/crf";
import {useCommonStore} from "@/stores/common.js"
const commonStore = useCommonStore()
// 定义组件属性
const props = defineProps({
  formModel: {},
  title: "",
  type: null
});


//不是筛选期
let notScreen = ref(false)
notScreen.value = commonStore.funNotScreen

//是不是v0
let isv0 = ref(false)
isv0.value = commonStore.isV0

let attrs =ref((notScreen.value?'补充':'既往')+'门脉高压介入治疗')

// 表单对象
const model = reactive(props.formModel);
const crfStore = useCrfStore();

// const onChange = {
//   "受试者是否进行过": (newValue) => {
//     if (newValue === "否") {
//       // 多选
//       [`${props.prefix}分流类型`].forEach((key) => {
//         model.fields[props.type][key] = [];
//       });

//       // 文本
//       [
//         `${props.prefix}手术日期`,
//         `${props.prefix}分流类型：BRTO球囊直径`,
//         `${props.prefix}分流类型：TIPS（）支架`,
//         `${props.prefix}TIPS支架直径（mm）`,
//         `${props.prefix}分流前PPG（mmHg）`,
//         `${props.prefix}分流后PPG（mmHg）`
//       ].forEach((key) => {
//         model.fields[props.type][key] = null;
//       });
//     }
//   },
//   "分流类型": (newValue) => {
//     console.log("分流类型", newValue);
//     if (newValue.indexOf("BRTO") === -1) {
//       // 分流类型没有选择BRTO
//       model.fields[props.type][`${props.prefix}分流类型：BRTO球囊直径（mm）`] = null;
//     }

//     if (newValue.indexOf("TIPS") === -1) {
//       // 分流类型没有选择TIPS
//       [
//         `${props.prefix}分流类型：TIPS（）支架`,
//         `${props.prefix}TIPS支架直径（mm）`,
//         `${props.prefix}分流前PPG（mmHg）`,
//         `${props.prefix}分流后PPG（mmHg）`
//       ].forEach((key) => {
//         model.fields[props.type][key] = null;
//       });
//     }
//   }
// };

// const title = computed(() => {
//   if (props.prefix) {
//     return props.prefix.replace("【", "").replace("】", "");
//   } else {
//     return "";
//   }
// });

// const isVisible = computed(() => {
//   let result = {};
//   // 单选的选择
//   [`${props.prefix}受试者是否进行过${title.value}_是`].forEach((field) => {
//     const key = field.split("_")[0];
//     const value = field.split("_")[1];
//     result[field] = model.fields[props.type][key] === value;
//   });

//   // 多选的选择
//   [`${props.prefix}分流类型_BRTO`, `${props.prefix}分流类型_TIPS`].forEach((field) => {
//     const key = field.split("_")[0];
//     const value = field.split("_")[1];
//     result[field] = model.fields[props.type][key] && model.fields[props.type][key].indexOf(value) > -1;
//   });

//   console.log("isVisible", result);
//   return result;
// });

// 节省代码长度，在模板中使用
const crfFields = computed(() => {
  return model.fields[props.type];
});

// 字段自动校验用于赋值 prop
const itemProp = function(prop) {
  return `fields['${props.type}']['${prop}']`;
};
</script>
<template>
  <template v-if="crfFields">
    <h3>{{attrs}}</h3> 
    <el-form-item label="是否适用肝筛选期补充门脉高压介入治疗数据"  v-if="crfFields && isv0" class="redStar">
      <el-radio-group v-if="notScreen" v-model="crfFields['补充门脉高压介入治疗是否适用肝筛选期数据']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>
      <template v-if="crfFields['补充门脉高压介入治疗是否适用肝筛选期数据'] == '否' || !isv0">
        <el-form-item :label="notScreen?'是否新增补充门脉高压介入治疗':'是否补充门脉高压介入治疗'" class="redStar pleft">
          <el-radio-group v-model="crfFields[`${attrs}`]">
                        <!--  @change="onChange['受试者是否进行过']" -->
            <el-radio label="是" prop="是"></el-radio>
            <el-radio label="否" prop="否"></el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="crfFields[attrs] == '是'">
            <el-form-item label="手术日期" class="redStar pleft2" :prop="itemProp(`${attrs}手术日期`)" :rules="crfStore.dateRules('手术日期')">
            <el-date-picker v-model="crfFields[`${attrs}手术日期`]"
                          type="date" placeholder="选择手术日期"
                          value-format="YYYY-MM-DD" />
            </el-form-item>
            <el-form-item  class="redStar pleft2" label="手术类型" :prop="itemProp(`${attrs}手术类型`)" :rules="crfStore.checkboxRules('手术类型')">
              <el-checkbox-group v-model="crfFields[`${attrs}手术类型`]">
                <el-checkbox label="PTVE" prop="PTVE"></el-checkbox>
                <el-checkbox label="BRTO" prop="BRTO"></el-checkbox>
                <el-checkbox label="TIPS" prop="TIPS"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <div class="pleft4">
                <el-form-item v-if="crfFields[`${attrs}手术类型`]?.includes('BRTO')" label="球囊直径（mm）" class="redStar">
                  <el-input v-model="crfFields[`${attrs}手术类型_BRTO球囊直径`]" placeholder="请输入球囊直径">
                    <template #append>mm</template>
                  </el-input>
                </el-form-item>
                <el-form-item v-if=" crfFields[`${attrs}手术类型`]?.includes('TIPS')" label="TIPS 支架" class="redStar">
                  <el-input v-model="crfFields[`${attrs}手术类型_TIPS支架`]" placeholder="请输入TIPS支架">
                  </el-input>
                </el-form-item>
                <el-form-item v-if=" crfFields[`${attrs}手术类型`]?.includes('TIPS')" label="支架直径 （mm）" class="redStar">
                  <el-input v-model="crfFields[`${attrs}手术类型_TIPS支架直径`]" placeholder="请输入支架直径">
                    <template #append>mm</template>
                  </el-input>
                </el-form-item>
                <el-form-item v-if=" crfFields[`${attrs}手术类型`]?.includes('TIPS')" label="分流前PPG（mmHg）" class="redStar">
                  <el-input v-model="crfFields[`${attrs}手术类型_分流前PPG`]" placeholder="请输入分流前PPG">
                    <template #append>mmHg</template>
                  </el-input>
                </el-form-item>
                <el-form-item v-if="crfFields[`${attrs}手术类型`]?.includes('TIPS')" label="分流后PPG（mmHg）" class="redStar">
                  <el-input v-model="crfFields[`${attrs}手术类型_分流后PPG`]" placeholder="请输入分流后PPG">
                    <template #append>mmHg</template>
                  </el-input>
                </el-form-item>
            </div>

        </template>
      </template>

   

  </template>
</template>

<style scoped>
</style>